<ui-selectbox name="region" class="region" [(ngModel)]="settings.region" *ngIf="showRegion" placeholder="Region"
  required>
  <ui-option value="AU">Australia and New Zealand</ui-option>
  <ui-option value="CA">Canada</ui-option>
  <ui-option value="EU">Europe</ui-option>
  <ui-option value="US">USA</ui-option>
</ui-selectbox>

<ui-selectbox name="export_format" class="format" [(ngModel)]="settings.exportFormat" placeholder="Output format"
  required>
  <ui-option value="Xml">.XML</ui-option>
  <ui-option value="Xls">.XLS</ui-option>
  <ui-option value="Csv">.CSV</ui-option>
  <ui-option value="Dbf">.DBF</ui-option>
  <ui-option value="Txt">.TXT</ui-option>
</ui-selectbox>

<ui-selectbox name="verification" class="verification" [(ngModel)]="settings.verificationType"
  placeholder="What documents do you want to verify?" required>
  <ui-option value="UserVerification">All</ui-option>
  <ui-option value="Troubleshooting">With Errors</ui-option>
  <ui-option value="NoVerification">None</ui-option>
</ui-selectbox>
